/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackupFileDto } from '../../models/backup-file-dto';
import { CustomLocalizationTarget } from '../../models/custom-localization-target';

export interface BackupLocalizations$Params {
  type: CustomLocalizationTarget;
  'X-API-Version'?: string;
}

export function backupLocalizations(http: HttpClient, rootUrl: string, params: BackupLocalizations$Params, context?: HttpContext): Observable<StrictHttpResponse<BackupFileDto>> {
  const rb = new RequestBuilder(rootUrl, backupLocalizations.PATH, 'get');
  if (params) {
    rb.path('type', params.type, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;auex-usage=resbu', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BackupFileDto>;
    })
  );
}

backupLocalizations.PATH = '/api/localizations/{type}/backup';
